import { Injectable } from '@angular/core';
import { BankAccountDetails, PaymentMethod } from '../models/payment-preferences.model';

@Injectable()
export class PaymentAccountUtilityService {
    maskAccountNumber(raw?: string | number): string {
        const acc = raw ? String(raw).trim() : '';

        if (acc.includes('*')) {
            return acc;
        }

        if (acc.length > 3) {
            return acc.replace(/\d(?=\d{3})/g, '*');
        }

        return '';
    }

    formatAccountLabel(account: BankAccountDetails): string {
        const bankName = account.bankName || 'Bank';
        const maskedNumber = this.maskAccountNumber(account.bankAccountNumber);
        const accountType = account.bankAccountType || '';

        return `${bankName} - ${maskedNumber} (${accountType})`;
    }

    buildPaymentMethodOptions(accounts: BankAccountDetails[]): PaymentMethod[] {
        return accounts.map((account) => ({
            key: account.publicID,
            value: this.formatAccountLabel(account)
        }));
    }

    getDefaultPaymentMethods(): PaymentMethod[] {
        return [
            { key: 'new-checking', value: 'Checking Account' },
            { key: 'new-savings', value: 'Savings Account' }
        ];
    }

    buildSuccessMessage(accountName: string, accountNumber: string): string {
        return `${accountName}-${accountNumber.slice(-4)}`;
    }

    formatReftAccountLabel(accountNumber: string): string {
        return `Automatic payment account ${accountNumber}`;
    }
}
